// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore } from '@atlassian/react-sweet-state';
import { actions } from './actions/main.tsx';
import type { Actions, State } from './actions/types.tsx';

export const initialState: State = {
	isInviteTeamDialogOpen: false,
	onDialogUpdated: () => Promise.resolve(null),
};

export const store = createStore<State, Actions>({
	name: 'jsd-invite-dialog-service',
	initialState,
	actions,
});
